<template>
  <div class="box">
    <h2 class="subtitle is-pulled-left">My Tasks</h2>

    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <!-- <th>Folder</th> -->
          <th>File</th>
          <th>Status</th>
          <th>Due Date</th>
        </tr>
      </thead>
      <tbody>
        <!-- <tr>
          <td>
            <div class="level">
              <span class="level-item icon is-medium">
                <img src="../../assets/img/icons/draft-icon.svg">
              </span>
              FOLDER NAME
            </div>
            </td>
          </td>
          <td>&nbsp;</td>
          <td>2019-09-28 00:12:11</td>
        </tr>-->
        <tr v-for="project in projects" :key="project.id">
          <td>
            <span class="icon is-small">
              <img src="../../assets/img/icons/file.svg">
            </span>
            <!-- <a @click.prevent="gotoEStudio(project.id)">{{project.name}}</a> -->
            <a
              @click.prevent="gotoProject($store.state.auth.user.groups[0].id, $store.state.auth.user.id, project.id)"
            >{{project.name}}</a>
          </td>
          <td>{{ getProjectStatus(project.id) }}</td>
          <td>{{ project.pivot.due_date.substring(0,19) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ACCESS_TOKEN, API_URL } from "../../Variables";
import BaseHelper from "../../helpers/BaseHelper";

export default {
  name: "FileBrowser",
  mixins: [BaseHelper],
  components: {},
  props: {
    projects: {
      type: Array,
      required: true
    },
    submissions: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: "journal"
    }
  },
  computed: {},
  data() {
    return {
      access_token: ACCESS_TOKEN,
      isLoading: false
    };
  },
  mounted() {},
  methods: {
    projectHasSubmission: function(projectId) {
      return this.submissions.find(
        document => document.project_id === projectId
      );
    },
    getProjectStatus: function(projectId) {
      if (this.projectHasSubmission(projectId)) {
        return "Submitted";
      } else {
        return "Not started";
      }
    }
  }
};
</script>

<style lang="scss" >
</style>